import { call, put, takeLatest } from 'redux-saga/effects';
import { LOGIN_REQUEST, VERIFY_OTP_REQUEST } from '../constants';
import { loginSuccess, loginFailure } from '../actions/authActions';
import { authAPI } from '../../utils/axiosInstance';
import Toast from '../../utils/commoncomponent/Toast';

const validRoles = ['student', 'tutor', 'admin', 'ops_manager', 'institution', 'coordinator'];

const extractAuthErrorMessage = (error, fallback = 'Invalid credentials. Please try again.') => {
  const data = error?.response?.data;
  const candidates = [
    data?.message,
    data?.errorMessage,
    data?.detail,
    data?.error,
    typeof data === 'string' ? data : null,
    error?.message,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      const trimmed = candidate.trim();
      // Axios/network noise should not be shown as-is.
      if (/^request failed with status code/i.test(trimmed)) {
        continue;
      }
      return trimmed;
    }
  }

  return fallback;
};

function* handleAuthSuccess(response) {
  const userRole = response.data.role;
  if (!validRoles.includes(userRole)) {
    const errorMessage = `Login failed: The role '${userRole}' is not valid.`;
    Toast.error(errorMessage);
    yield put(loginFailure({ status: 'FAILURE', message: errorMessage }));
    return;
  }
  yield put(loginSuccess(response.data));
}

function* authSaga(action) {
  try {
    const response = yield call([authAPI, 'post'], '/signin', action.payload);
    yield* handleAuthSuccess(response);
  } catch (error) {
    console.log('Error from auth saga', error);
    const message = extractAuthErrorMessage(
      error,
      'Invalid credentials. Please try again.',
    );
    Toast.error(message);
    yield put(loginFailure({ status: 'FAILURE', message }));
  }
}

function* verifyOtpSaga(action) {
  try {
    const response = yield call([authAPI, 'post'], '/verifyEmailOtp', action.payload);
    if (response.data.status === 'VERIFICATION_EMAIL_FAILED') {
      Toast.info('Your verification code expired. A new code has been sent to your email.');
      yield put(
        loginFailure({
          status: 'FAILURE',
          message: response.data.message || response.data.status,
        }),
      );
      return;
    }
    yield* handleAuthSuccess(response);
  } catch (error) {
    console.log('Error from verify OTP saga', error);
    const message = extractAuthErrorMessage(error, 'Invalid verification code');
    Toast.error(message);
    yield put(loginFailure({ status: 'FAILURE', message }));
  }
}

export default function* watchAuth() {
  yield takeLatest(LOGIN_REQUEST, authSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);
}
